webpackJsonp([17],{

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(332);
module.exports = __webpack_require__(404);


/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchArticleBody;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchOddsChange;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appInitApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return newsApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return matchApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return matchDetailApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return statsApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return videoApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return tweetApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig__ = __webpack_require__(460);





var requestConfig = __webpack_require__(82);
var apiDomain =  false ? requestConfig.apiDomain : '';

function fetchArticleBody(articleId) {
    var id = articleId.match(/^\d+/g);
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiDomain + '/m/v2/article/body/' + (id ? id[0] : '') + '?plat=m').then(function (response) {
        return response.data;
    }).catch(function (error) {
        return error;
    });
}

function fetchOddsChange(options) {
    console.log('options', options);
    var url = apiDomain + '/data/odds/detail/' + options.id + '?companyId=' + options.companyId + '&type=' + options.type + '&rate=' + options.rate;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
        console.log('response.data', response.data);
        return response.data;
    }).catch(function (error) {
        return error;
    });
}

var appInitApi = {
    menusApi: function menusApi() {
        var _url = __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* menuListHome */];
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_url).then(function (response) {
            return response.data;
        });
    },
    matchMenusApi: function matchMenusApi() {
        var _url = __WEBPACK_IMPORTED_MODULE_1__urlConfig__["b" /* menuListMatch */];
        console.log('_url', _url);

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_url).then(function (response) {
            return response.data;
        });
    },
    statsMenusApi: function statsMenusApi() {
        var _url = __WEBPACK_IMPORTED_MODULE_1__urlConfig__["c" /* menuListStats */];
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_url).then(function (response) {
            return response.data;
        });
    },
    videoMenusApi: function videoMenusApi() {
        var _url = __WEBPACK_IMPORTED_MODULE_1__urlConfig__["d" /* menuListVideo */];
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_url).then(function (response) {
            return response.data;
        });
    }
};

var newsApi = {
    getNewsList: function getNewsList(_url) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_url).then(function (response) {
            return response.data;
        });
    }
};

var matchApi = {
    getMatchList: function getMatchList(_url) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_url).then(function (response) {
            return response.data;
        });
    }
};

var matchDetailApi = {
    fetchMatchDetailFormation: function fetchMatchDetailFormation(matchId) {
        var url = apiDomain + '/m/data/detail/match/' + matchId + '?plat=m';
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
            return response.data;
        });
    },
    fetchMatchOverviewFormation: function fetchMatchOverviewFormation(matchId, locale) {
        var url = apiDomain + '/data/event/match/' + matchId + '?isJSON=true&language=' + locale;
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
            return response.data;
        });
    },
    fetchMatchAnalysisFormation: function fetchMatchAnalysisFormation(matchId, locale, isJSON) {
        var url = apiDomain + '/data/new/pre_analysis/' + matchId + '?isJSON=' + isJSON + '&language=' + locale;
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
            return response.data;
        });
    },
    fetchMatchOddsEuro: function fetchMatchOddsEuro(matchId) {
        var url = apiDomain + '/data/odds_data/summary/euro/' + matchId;
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
            return response.data;
        });
    },
    fetchMatchOddsAsia: function fetchMatchOddsAsia(matchId) {
        var url = apiDomain + '/data/odds_data/summary/asia/' + matchId;
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
            return response.data;
        });
    },
    fetchMatchOddsOverUnder: function fetchMatchOddsOverUnder(matchId) {
        var url = apiDomain + '/data/odds_data/summary/over_under/' + matchId;
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
            return response.data;
        });
    }
};

var statsApi = {
    getStatsList: function getStatsList(_url) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_url).then(function (response) {
            return response.data;
        });
    }
};

var videoApi = {
    getVideoList: function getVideoList(_url) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_url).then(function (response) {
            return response.data;
        });
    }
};

var tweetApi = {
    fetchTweetArticleInfo: function fetchTweetArticleInfo(_url) {
        console.log('url====', _url);
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_url).then(function (response) {
            return response.data;
        });
    }
};

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise_auto__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(427);





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        var asyncData = this.$options.asyncData;

        if (asyncData) {
            asyncData({
                store: this.$store,
                route: to
            }).then(next).catch(next);
        } else {
            next();
        }
    }
});

var _createApp = Object(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* createApp */])(),
    app = _createApp.app,
    router = _createApp.router,
    store = _createApp.store;

if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__);
}

router.onReady(function () {
    router.beforeResolve(function (to, from, next) {
        var matched = router.getMatchedComponents(to);
        var prevMatched = router.getMatchedComponents(from);
        var diffed = false;
        var activated = matched.filter(function (c, i) {
            return diffed || (diffed = prevMatched[i] !== c);
        });
        var asyncDataHooks = activated.map(function (c) {
            return c.asyncData;
        }).filter(function (_) {
            return _;
        });
        if (!asyncDataHooks.length) {
            return next();
        }

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(asyncDataHooks.map(function (hook) {
            return hook({ store: store, route: to });
        })).then(function () {
            next();
        }).catch(next);
    });

    app.$mount('#app');
});

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createApp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_vue__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_performance__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_performance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util_performance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_js_format__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_js_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__public_js_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_toast__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_css__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__app_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_toast_lib_toast_css__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_toast_lib_toast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_toast_lib_toast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_i18n__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lang_index_js__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lang_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__lang_index_js__);
















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue2_toast___default.a, {
    defaultType: 'center',
    duration: 3000,
    wordWrap: true
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */]({
    locale: 'en',
    fallbackLocale: 'en',
    messages: __WEBPACK_IMPORTED_MODULE_12__lang_index_js___default.a
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a, {
    keyName: 'head',
    attribute: 'data-vue-meta',
    ssrAttribute: 'data-vue-meta-server-rendered',
    tagIDKeyName: 'vmid' });
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

var isWebpSupport = function () {
    var support = null;
    return function (that) {
        if (support !== null) {
            return support;
        }
        if (true) {
            var elem = document.createElement('canvas');

            if (elem.getContext && elem.getContext('2d')) {
                support = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
            } else {
                support = false;
            }
        } else if (that && that.$ssrContext && that.$ssrContext.userAgent) {
            var userAgent = that.$ssrContext.userAgent;
            if (userAgent.indexOf('opera') > -1 || userAgent.indexOf('chrome') > -1) {
                support = true;
            } else {
                support = false;
            }
        }
        return support;
    };
}();

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
    created: function created() {
        if (this.$route && this.$route.query) {
            var locale = this.$route.query.language || '';
            locale = locale.split('-')[0];
            i18n.locale = locale || 'en';
        }
    },

    methods: {
        getUrlTitle: function getUrlTitle(title) {
            return title && encodeURIComponent(title.split(/[:%#;,&[\]!?"'/\\]/).join('').split(' ').join('-'));
        },
        getImgSrc: function getImgSrc(src) {
            if (!src) {
                return '';
            }
            if (src.indexOf('img.allfootballapp.com') > -1 && /.(jpe?g|png)/.test(src)) {
                if (isWebpSupport(this)) {
                    src = src + '.webp';
                }
            }

            return src.replace(/https?:\/\//, '//').replace('//img.allfootballapp.com', '//img.allfootballapp.com').replace('//s3.allfootballapp.com', '//s3.allfootballapp.com');
        }
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive('teamLogo', {
    inserted: function inserted(el) {
        var defaultSrc = location.protocol === 'https:' ? 'https://img-sd.allfootballapp.com/fastdfs3/M00/B9/F9/ChOxM1xIEDOAbu7VAAAWn39BUY0523.png' : 'http://img-sd.allfootballapp.com/fastdfs3/M00/B9/F9/ChOxM1xIEDOAbu7VAAAWn39BUY0523.png';

        if (!el.src) {
            el.src = defaultSrc;
        }

        el.onerror = function () {
            el.src = defaultSrc;
        };
    }
});

function createApp() {
    var router = Object(__WEBPACK_IMPORTED_MODULE_3__router__["a" /* createRouter */])();
    var store = Object(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* createStore */])();
    var app = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        router: router,
        store: store,
        i18n: i18n
    }, __WEBPACK_IMPORTED_MODULE_5__App_vue___default.a));
    return { app: app, router: router, store: store };
}

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(433);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var pathToRegexp = __webpack_require__(434);

function createRouter() {
    var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
        mode: 'history',
        scrollBehavior: function scrollBehavior(to, from, savedPosition) {
            savedPosition = from.meta.savedPosition;
            if (savedPosition) {
                return savedPosition;
            } else {
                var position = {};

                if (to.matched.some(function (m) {
                    return m.meta.scrollToTop;
                })) {
                    position.x = 0;
                    position.y = 0;
                }

                return position;
            }
        },

        routes: [{
            path: '/',
            redirect: function redirect(to) {
                return {
                    name: 'news'
                };
            }
        }, {
            path: '/home',
            redirect: function redirect(to) {
                if (to.query.subtitle) {
                    return 'news/' + to.query.subtitle;
                } else {
                    return { name: 'news' };
                }
            }
        }, {
            path: '/match',
            redirect: function redirect(to) {
                if (to.query.subtitle) {
                    return '/matchs/' + to.query.subtitle;
                } else {
                    return '/matchs';
                }
            }
        }, {
            path: '/news',
            redirect: function redirect(to) {
                if (to.query.id) {
                    if (to.query.subtitle) {
                        return '/news/' + to.query.subtitle + '/' + to.query.id;
                    } else {
                        return '/news/Headline/' + to.query.id;
                    }
                } else {
                    return { name: 'news' };
                }
            }
        }, {
            path: '/matchDetail',
            redirect: function redirect(to) {
                if (to.query.subtitle && to.query.id) {
                    return '/match/' + to.query.subtitle + '/' + to.query.id;
                } else {
                    return 'matchs';
                }
            }
        }, {
            path: '/news/:subtitle(^[A-Za-z0-9]+$)?/:title?/:id?',
            name: 'news',
            component: function component() {
                return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 484));
            },
            meta: {
                keepAlive: true,
                scrollToTop: false
            }
        }, {
            path: '/video/:subtitle?',
            component: function component() {
                return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 485));
            },
            meta: { keepAlive: true, scrollToTop: false }
        }, {
            path: '/match/:subtitle/:title?/:id',
            component: function component() {
                return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 486));
            },
            meta: {
                keepAlive: false
            }
        }, {
            path: '/stats/:subtitle?',
            component: function component() {
                return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 487));
            },
            meta: {
                keepAlive: false
            }
        }, {
            path: '/matchs/:subtitle([A-Za-z0-9]+)?',
            component: function component() {
                return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 488));
            },
            meta: {
                keepAlive: false
            }
        }, {
            path: '/news/:subtitle/:title?/:id([0-9]+)',

            component: function component() {
                return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 489));
            },
            meta: {
                keepAlive: false,
                scrollToTop: true
            }
        }, {
            path: '/matchOdds',
            component: function component() {
                return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 490));
            },
            meta: {
                keepAlive: false
            }
        }, { path: '/download', component: function component() {
                return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 491));
            } }, { path: '/downloadNew', component: function component() {
                return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 492));
            } }, { path: '/downloadApp', component: function component() {
                return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 330));
            } }, { path: '/downloadCoin', component: function component() {
                return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 493));
            } }, { path: '/live', component: function component() {
                return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 494));
            } }, { path: '/answerShare', component: function component() {
                return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 495));
            } }, { path: '/wakeUp', component: function component() {
                return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 496));
            } }, {
            path: '/tweet',
            component: function component() {
                return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 497));
            },
            meta: {
                keepAlive: false,
                scrollToTop: true
            }
        }, {
            path: '/minapp',
            component: function component() {
                return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 498));
            },
            meta: {
                keepAlive: false,
                scrollToTop: true
            }
        }, {
            path: '*',
            name: '404',
            component: function component() {
                return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 330));
            }
        }]
    });
    router.beforeEach(function (to, from, next) {
        if (typeof ga === 'function') {
            ga('send', 'pageview', to.path);
        }
        next();
    });
    return router;
}

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_navStore__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_matchDetailStore__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_homeListStore__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_matchListStore__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_statsListStore__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_videoListStore__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_tweetStore__ = __webpack_require__(470);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

function createStore() {
    return new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
        state: {
            articlebody: {},
            relative: {},
            comments: {},
            oddsChange: []
        },
        actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
        mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
        getters: __WEBPACK_IMPORTED_MODULE_4__getters___default.a,
        modules: {
            navStore: __WEBPACK_IMPORTED_MODULE_5__modules_navStore__["a" /* default */],
            matchListStore: __WEBPACK_IMPORTED_MODULE_8__modules_matchListStore__["a" /* default */],
            matchDetailStore: __WEBPACK_IMPORTED_MODULE_6__modules_matchDetailStore__["a" /* default */],
            homeListStore: __WEBPACK_IMPORTED_MODULE_7__modules_homeListStore__["a" /* default */],
            statsListStore: __WEBPACK_IMPORTED_MODULE_9__modules_statsListStore__["a" /* default */],
            videoListStore: __WEBPACK_IMPORTED_MODULE_10__modules_videoListStore__["a" /* default */],
            tweetStore: __WEBPACK_IMPORTED_MODULE_11__modules_tweetStore__["a" /* default */]
        }
    });
}

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(36);




/* harmony default export */ __webpack_exports__["a"] = ({

    FETCH_ARTICLEBODY: function FETCH_ARTICLEBODY(_ref, _ref2) {
        var commit = _ref.commit,
            state = _ref.state;
        var article_id = _ref2.article_id;

        return state.articlebody[article_id] ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(state.articlebody[article_id]) : Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* fetchArticleBody */])(article_id).then(function (_articlebody) {
            return commit('SET_ARTICLEBODY', {
                articleId: article_id,
                _articlebody: _articlebody
            });
        });
    },
    FETCH_ODDSCHANGE: function FETCH_ODDSCHANGE(_ref3, options) {
        var commit = _ref3.commit,
            state = _ref3.state;

        return state.oddsChange.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(state.oddsChange) : Object(__WEBPACK_IMPORTED_MODULE_2__api__["c" /* fetchOddsChange */])(options).then(function (_oddsChange) {
            return commit('SET_ODDSCHANGE', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options, {
                _oddsChange: _oddsChange
            }));
        });
    }
});

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return menuListHome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return menuListMatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return menuListStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return menuListVideo; });
var requestConfig = __webpack_require__(82);
var apiDomain =  false ? requestConfig.apiDomain : '';

var menuListHome = apiDomain + '/m/app/global/2/m_new.json?plat=m';
var menuListMatch = apiDomain + '/m/app/global/2/m.json?menu=match&plat=m';
var menuListStats = apiDomain + '/m/app/global/2/m.json?menu=stats&plat=m';
var menuListVideo = apiDomain + '/m/app/global/2/m_new.json?menu=video&plat=m';

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
    SET_ARTICLEBODY: function SET_ARTICLEBODY(state, _ref) {
        var articleId = _ref.articleId,
            _articlebody = _ref._articlebody;

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.articlebody, articleId, _articlebody || false);
    },

    SET_RELATIVE: function SET_RELATIVE(state, _ref2) {
        var articleId = _ref2.articleId,
            _relative = _ref2._relative;

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.relative, articleId, _relative || false);
    },
    SET_COMMENTS: function SET_COMMENTS(state, _ref3) {
        var articleId = _ref3.articleId,
            _comments = _ref3._comments;

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.comments, articleId, _comments || false);
    },
    SET_ODDSCHANGE: function SET_ODDSCHANGE(state, _ref4) {
        var _oddsChange = _ref4._oddsChange;

        console.log('_oddsChange', _oddsChange);
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'oddsChange', _oddsChange.teamData || false);
    }
});

/***/ }),

/***/ 462:
/***/ (function(module, exports) {



/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(36);


var state = {
    homeSubTabList: [],
    matchSubTabList: [],
    statsSubTabList: [],
    videoSubTabList: [],
    subtitChoose: '',
    thirdTitChoose: '' };

var getters = {
    getHomeSubTabList: function getHomeSubTabList(state) {
        return state.homeSubTabList;
    },
    getMatchSubTabList: function getMatchSubTabList(state) {
        return state.matchSubTabList;
    },
    getStatsSubTabList: function getStatsSubTabList(state) {
        return state.statsSubTabList;
    },
    getVideoSubTabList: function getVideoSubTabList(state) {
        return state.videoSubTabList;
    },
    getSubtitChoose: function getSubtitChoose(state) {
        return state.subtitChoose;
    },
    getThirdTitChoose: function getThirdTitChoose(state) {
        return state.thirdTitChoose;
    }
};

var actions = {
    menusListApi: function menusListApi(_ref, _ref2) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;
        var subtitle = _ref2.subtitle,
            type = _ref2.type;

        state.subtitChoose = subtitle && subtitle.replace(/-/g, ' ');
        if (type === 'NEWS') {
            return __WEBPACK_IMPORTED_MODULE_0__api_index__["a" /* appInitApi */].menusApi().then(function (response) {
                commit('setHomeMenuList', response);
            }, function (error) {
                console.log(error);
            });
        } else if (type === 'MATCH') {
            return __WEBPACK_IMPORTED_MODULE_0__api_index__["a" /* appInitApi */].matchMenusApi().then(function (response) {
                commit('setMatchMenuList', response);
            }, function (error) {
                console.log(error);
            });
        } else if (type === 'STATS') {
            return __WEBPACK_IMPORTED_MODULE_0__api_index__["a" /* appInitApi */].statsMenusApi().then(function (response) {
                commit('setStatsMenuList', response);
            }, function (error) {
                console.log(error);
            });
        } else if (type === 'VIDEO') {
            return __WEBPACK_IMPORTED_MODULE_0__api_index__["a" /* appInitApi */].videoMenusApi().then(function (response) {
                commit('setVideoMenuList', response);
            }, function (error) {
                console.log(error);
            });
        }
    }
};

var mutations = {
    setHomeMenuList: function setHomeMenuList(state, params) {
        state.homeSubTabList = [];
        params.menus.news.forEach(function (e) {
            var dataSubtit = { 'label': e.label, 'urlApi': e.api };
            state.homeSubTabList.push(dataSubtit);
        });
        if (!state.subtitChoose && state.homeSubTabList[0]) {
            state.subtitChoose = state.homeSubTabList[0].label;
        }
    },
    setMatchMenuList: function setMatchMenuList(state, params) {
        state.matchSubTabList = [];
        params.menus.match_tab.forEach(function (e) {
            var dataSubtit = { 'label': e.label, 'urlApi': e.api };
            state.matchSubTabList.push(dataSubtit);
        });
        if (!state.subtitChoose && state.matchSubTabList[0]) {
            state.subtitChoose = state.matchSubTabList[0].label;
        }
    },
    setStatsMenuList: function setStatsMenuList(state, params) {
        state.statsSubTabList = [];
        params.menus.ranking.forEach(function (e) {
            var dataSubtit = { 'label': e.label, 'urlApi': e.sub_tabs };
            state.statsSubTabList.push(dataSubtit);
        });
        if (!state.subtitChoose && state.statsSubTabList[0]) {
            state.subtitChoose = state.statsSubTabList[0].label;
        }
        if (!state.thirdTitChoose && state.thirdTitChoose[0]) {
            state.thirdTitChoose = state.statsSubTabList[0].sub_tabs[0].title;
        }
    },
    setVideoMenuList: function setVideoMenuList(state, params) {
        state.videoSubTabList = [];
        params.menus.video.forEach(function (e) {
            var dataSubtit = { 'label': e.label, 'urlApi': e.api };
            state.videoSubTabList.push(dataSubtit);
        });
        if (!state.subtitChoose && state.videoSubTabList[0]) {
            state.subtitChoose = state.videoSubTabList[0].label;
        }
    },
    setSubtitChoose: function setSubtitChoose(state, params) {
        state.subtitChoose = params;
    },
    setThirdTitChoose: function setThirdTitChoose(state, params) {
        state.thirdTitChoose = params;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_index__ = __webpack_require__(36);



var state = {
    matchDetailFormation: {},
    matchOverviewFormation: {},
    matchAnalysisFormation: {},
    matchOddsFormation: {
        euro: [],
        asia: [],
        overUnder: []
    }
};

var actions = {
    FETCH_MATCH_DETAIL_FORMATION: function FETCH_MATCH_DETAIL_FORMATION(_ref, _ref2) {
        var commit = _ref.commit,
            state = _ref.state;
        var matchId = _ref2.matchId;

        return __WEBPACK_IMPORTED_MODULE_1__api_index__["e" /* matchDetailApi */].fetchMatchDetailFormation(matchId).then(function (matchDetailFormation) {
            return commit('SET_MATCH_DETAIL_FORMATION', {
                matchId: matchId,
                matchDetailFormation: matchDetailFormation
            });
        }).catch(function (error) {
            return console.log(error);
        });
    },
    FETCH_MATCH_OVERVIEW_FORMATION: function FETCH_MATCH_OVERVIEW_FORMATION(_ref3, _ref4) {
        var commit = _ref3.commit,
            state = _ref3.state;
        var matchId = _ref4.matchId,
            locale = _ref4.locale;

        return __WEBPACK_IMPORTED_MODULE_1__api_index__["e" /* matchDetailApi */].fetchMatchOverviewFormation(matchId, locale).then(function (matchOverviewFormation) {
            return commit('SET_MATCH_OVERVIEW_FORMATION', {
                matchId: matchId,
                matchOverviewFormation: matchOverviewFormation
            });
        }).catch(function (error) {
            return console.log(error);
        });
    },
    FETCH_MATCH_ANALYSIS_FORMATION: function FETCH_MATCH_ANALYSIS_FORMATION(_ref5, _ref6) {
        var commit = _ref5.commit,
            state = _ref5.state;
        var matchId = _ref6.matchId,
            locale = _ref6.locale,
            isJSON = _ref6.isJSON;

        return __WEBPACK_IMPORTED_MODULE_1__api_index__["e" /* matchDetailApi */].fetchMatchAnalysisFormation(matchId, locale, isJSON).then(function (matchAnalysisFormation) {
            return commit('SET_MATCH_ANALYSIS_FORMATION', {
                matchId: matchId,
                matchAnalysisFormation: matchAnalysisFormation
            });
        }).catch(function (error) {
            return console.log(error);
        });
    },
    FETCH_MATCH_ODDS_EURO: function FETCH_MATCH_ODDS_EURO(_ref7, _ref8) {
        var commit = _ref7.commit,
            state = _ref7.state;
        var matchId = _ref8.matchId;

        return __WEBPACK_IMPORTED_MODULE_1__api_index__["e" /* matchDetailApi */].fetchMatchOddsEuro(matchId).then(function (euro) {
            return commit('SET_MATCH_ODDS_EURO', {
                matchId: matchId,
                euro: euro
            });
        }).catch(function (error) {
            return console.log(error);
        });
    },
    FETCH_MATCH_ODDS_ASIA: function FETCH_MATCH_ODDS_ASIA(_ref9, _ref10) {
        var commit = _ref9.commit,
            state = _ref9.state;
        var matchId = _ref10.matchId;

        return __WEBPACK_IMPORTED_MODULE_1__api_index__["e" /* matchDetailApi */].fetchMatchOddsAsia(matchId).then(function (asia) {
            return commit('SET_MATCH_ODDS_ASIA', {
                matchId: matchId,
                asia: asia
            });
        }).catch(function (error) {
            return console.log(error);
        });
    },
    FETCH_MATCH_ODDS_OVER_UNDER: function FETCH_MATCH_ODDS_OVER_UNDER(_ref11, _ref12) {
        var commit = _ref11.commit,
            state = _ref11.state;
        var matchId = _ref12.matchId;

        return __WEBPACK_IMPORTED_MODULE_1__api_index__["e" /* matchDetailApi */].fetchMatchOddsOverUnder(matchId).then(function (overUnder) {
            return commit('SET_MATCH_ODDS_OVER_UNDER', {
                matchId: matchId,
                overUnder: overUnder
            });
        }).catch(function (error) {
            return console.log(error);
        });
    }
};
var mutations = {
    SET_MATCH_DETAIL_FORMATION: function SET_MATCH_DETAIL_FORMATION(state, _ref13) {
        var matchId = _ref13.matchId,
            matchDetailFormation = _ref13.matchDetailFormation;

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'matchDetailFormation', matchDetailFormation, matchId || false);
    },
    SET_MATCH_OVERVIEW_FORMATION: function SET_MATCH_OVERVIEW_FORMATION(state, _ref14) {
        var matchId = _ref14.matchId,
            matchOverviewFormation = _ref14.matchOverviewFormation;

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'matchOverviewFormation', matchOverviewFormation, matchId || false);
    },
    SET_MATCH_ANALYSIS_FORMATION: function SET_MATCH_ANALYSIS_FORMATION(state, _ref15) {
        var matchId = _ref15.matchId,
            matchAnalysisFormation = _ref15.matchAnalysisFormation;

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'matchAnalysisFormation', matchAnalysisFormation, matchId || false);
    },
    SET_MATCH_ODDS_EURO: function SET_MATCH_ODDS_EURO(state, _ref16) {
        var matchId = _ref16.matchId,
            euro = _ref16.euro;

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.matchOddsFormation, 'euro', euro);
    },
    SET_MATCH_ODDS_ASIA: function SET_MATCH_ODDS_ASIA(state, _ref17) {
        var matchId = _ref17.matchId,
            asia = _ref17.asia;

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.matchOddsFormation, 'asia', asia);
    },
    SET_MATCH_ODDS_OVER_UNDER: function SET_MATCH_ODDS_OVER_UNDER(state, _ref18) {
        var matchId = _ref18.matchId,
            overUnder = _ref18.overUnder;

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.matchOddsFormation, 'overUnder', overUnder);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(36);


var state = {
    loading: true,
    carouselData: [],
    noDataMode: false,
    loadingShow: false,
    currentListData: [],
    loadPrev: '/m/app/tabs/1.json?plat=m',
    loadNext: '/m/app/tabs/1.json?plat=m' };

var getters = {
    getLoading: function getLoading(state) {
        return state.loading;
    },
    getCarouselData: function getCarouselData(state) {
        return state.carouselData;
    },
    getNoDataMode: function getNoDataMode(state) {
        return state.noDataMode;
    },
    getLoadingShow: function getLoadingShow(state) {
        return state.loadingShow;
    },
    getCurrentListData: function getCurrentListData(state) {
        return state.currentListData;
    },
    getLoadPrev: function getLoadPrev(state) {
        return state.loadPrev;
    },
    getLoadNext: function getLoadNext(state) {
        return state.loadNext;
    }
};

var actions = {
    newsListApi: function newsListApi(_ref, _ref2) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;
        var urlApi = _ref2.urlApi;

        state.loadingShow = true;
        return __WEBPACK_IMPORTED_MODULE_0__api_index__["f" /* newsApi */].getNewsList(urlApi).then(function (response) {
            commit('getNewsList', response);
        }, function (error) {
            console.log('error', error);
        });
    }
};

var mutations = {
    getNewsList: function getNewsList(state, params) {
        console.log('getNewsList');
        state.loading = false;
        if (params.recommend) {
            state.carouselData = params.recommend;
        }
        if (params.articles.length) {
            state.noDataMode = false;
            state.loadingShow = false;
            state.currentListData = params.articles;
            state.loadPrev = params.prev.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '');
            state.loadNext = params.next.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '');
        } else {
            state.noDataMode = true;
            state.loadingShow = false;
        }
    },
    setLoading: function setLoading(state, params) {
        state.loading = params;
    },
    setLoadNext: function setLoadNext(state, params) {
        state.loadNext = params;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatDate__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lib_formatDate__);



var state = {
    noDataMode: false,
    loadingShow: true,
    downloadFooterShow: false,
    currentListData: [],
    finalListSplitDateData: {}
};

var getters = {
    getMatchNoDataMode: function getMatchNoDataMode(state) {
        return state.noDataMode;
    },
    getMatchLoadingShow: function getMatchLoadingShow(state) {
        return state.loadingShow;
    },
    getDownloadFooterShow: function getDownloadFooterShow(state) {
        return state.downloadFooterShow;
    },
    getCurrentMatchListData: function getCurrentMatchListData(state) {
        return state.currentListData;
    },
    getFinalListSplitDateData: function getFinalListSplitDateData(state) {
        return state.finalListSplitDateData;
    } };

var actions = {
    matchListApi: function matchListApi(_ref, _ref2) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;
        var urlApi = _ref2.urlApi,
            finalDate = _ref2.finalDate;

        var _url = urlApi + '?start=' + finalDate || '';
        state.loadingShow = true;
        return __WEBPACK_IMPORTED_MODULE_0__api_index__["d" /* matchApi */].getMatchList(_url).then(function (response) {
            commit('getMatchList', response);
        }, function (error) {
            console.log('error', error);
        });
    }
};

var mutations = {
    getMatchList: function getMatchList(state, params) {
        state.loadingShow = false;
        state.downloadFooterShow = true;
        state.currentListData = [];
        state.finalListSplitDateData = {};
        if (params.list.length) {
            state.noDataMode = false;
            state.currentListData = params.list;
            state.currentListData.forEach(function (elem, index) {
                var obj = __WEBPACK_IMPORTED_MODULE_1__lib_formatDate___default()(elem.start_play);
                elem.localdate = obj;
                if (!state.finalListSplitDateData[elem.localdate.local_ymd + ' ' + elem.localdate.local_day]) {
                    state.finalListSplitDateData[elem.localdate.local_ymd + ' ' + elem.localdate.local_day] = [];
                }
                state.finalListSplitDateData[elem.localdate.local_ymd + ' ' + elem.localdate.local_day][state.finalListSplitDateData[elem.localdate.local_ymd + ' ' + elem.localdate.local_day].length] = elem;
            });
        } else {
            state.noDataMode = true;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

var dateToDubble = function dateToDubble(str) {
    if (str < 10) {
        return '0' + str;
    } else {
        return str;
    }
};

var formatDate = function formatDate(gmtDate) {
    var date = new Date(gmtDate.replace(/-/g, '/')).getTime();
    var diff_min = new Date().getTimezoneOffset();
    var local_date = new Date(date - diff_min * 60 * 1000);
    var local_month = local_date.getMonth() + 1;
    local_month = dateToDubble(local_month);
    var local_timeDetail = ('' + local_date).split(' ');
    var local_ymd = local_timeDetail[3] + '-' + local_month + '-' + local_timeDetail[2];

    var dateToday = new Date();

    var dateYesterday = new Date();
    dateYesterday.setTime(dateToday.getTime() - 24 * 60 * 60 * 1000);
    var yesterdayMonth = dateYesterday.getMonth() + 1;
    var yesterdayDate = dateYesterday.getDate();
    yesterdayMonth = dateToDubble(yesterdayMonth);
    yesterdayDate = dateToDubble(yesterdayDate);
    var yesterDayGetDate = dateYesterday.getFullYear() + '-' + yesterdayMonth + '-' + yesterdayDate;

    var dateTomorrow = new Date();
    dateTomorrow.setTime(dateToday.getTime() + 24 * 60 * 60 * 1000);
    var tomorrowMonth = dateTomorrow.getMonth() + 1;
    var tomorrowDate = dateTomorrow.getDate();
    tomorrowMonth = dateToDubble(tomorrowMonth);
    tomorrowDate = dateToDubble(tomorrowDate);
    var tomorrowGetDate = dateTomorrow.getFullYear() + '-' + tomorrowMonth + '-' + tomorrowDate;

    var year = dateToday.getFullYear();
    var mon = dateToday.getMonth() + 1;
    var dayy = dateToday.getDate();
    mon = dateToDubble(mon);
    dayy = dateToDubble(dayy);
    var today = year + '-' + mon + '-' + dayy;

    var date1 = new Date(today);
    var date2 = new Date(local_ymd);
    var date3 = new Date(yesterDayGetDate);
    var date4 = new Date(tomorrowGetDate);

    if (date1.getTime() == date2.getTime()) {
        local_timeDetail[0] = 'Today';
    } else if (date3.getTime() == date2.getTime()) {
        local_timeDetail[0] = 'Yesterday';
    } else if (date4.getTime() == date2.getTime()) {
        local_timeDetail[0] = 'Tomorrow';
    } else {
        local_timeDetail[0] = local_timeDetail[0].toUpperCase();
    }

    return {
        local_ymd: local_timeDetail[3] + '-' + local_month + '-' + local_timeDetail[2],
        local_hms: local_timeDetail[4].slice(0, 5),
        local_day: local_timeDetail[0]
    };
};
module.exports = formatDate;

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(36);


var formatDate = function formatDate(gmtDate) {
    var date = new Date(gmtDate.replace(/-/g, '/')).getTime();
    var diffMin = new Date().getTimezoneOffset();
    var localDate = new Date(date - diffMin * 60 * 1000);
    var localMonth = dateToDubble(localDate.getMonth() + 1);
    var localTimeDetail = ('' + localDate).split(' ');
    var localMdHm = localMonth + '-' + localTimeDetail[2] + ' ' + localTimeDetail[4].split(':')[0] + ':' + localTimeDetail[4].split(':')[1];
    return {
        finalTime_md_hm: localMdHm
    };
};
var dateToDubble = function dateToDubble(str) {
    if (str < 10) {
        return '0' + str;
    } else {
        return str;
    }
};
var putLocalTimeToData = function putLocalTimeToData(dataToTransfer) {
    if (dataToTransfer) {
        dataToTransfer.forEach(function (elem, index) {
            if (elem.template === 'team_point_ranking_match') {
                elem.content.data.forEach(function (e, i) {
                    if (e.start_play) {
                        var dateTime = e.start_play;
                        e.finalIneedTime = formatDate(dateTime);
                    }
                });
            } else if (elem.template === 'team_point_ranking_aggregate') {
                elem.content.data.forEach(function (e, i) {
                    if (e.match1.start_play) {
                        var dateTime = e.match1.start_play;
                        e.match1.finalIneedTime = formatDate(dateTime);
                    }
                    if (e.match2.start_play) {
                        var dateTime1 = e.match2.start_play;
                        e.match2.finalIneedTime = formatDate(dateTime1);
                    }
                });
            }
        });
    }
};

var state = {
    noDataMode: false,
    loadingShow: true,
    currentListData: null,
    currentTab: ''
};
var getters = {
    getStatsNoDataMode: function getStatsNoDataMode(state) {
        return state.noDataMode;
    },
    getStatsLoadingShow: function getStatsLoadingShow(state) {
        return state.loadingShow;
    },
    getCurrentStatsListData: function getCurrentStatsListData(state) {
        return state.currentListData;
    } };

var actions = {
    statsListApi: function statsListApi(_ref, _ref2) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;
        var urlApi = _ref2.urlApi,
            thirdTitChoose = _ref2.thirdTitChoose;

        var _url = '' + urlApi || '';
        state.loadingShow = true;
        return __WEBPACK_IMPORTED_MODULE_0__api_index__["g" /* statsApi */].getStatsList(_url).then(function (response) {
            if (thirdTitChoose === 'Goals' || thirdTitChoose === 'Assists') {
                commit('getGoalsStatsList', response);
                return;
            }
            if (thirdTitChoose === 'Fixtures') {
                commit('getFixturesStatsList', response);
                return;
            }
            commit('getTableStatsList', response);
        }, function (error) {
            console.log('error', error);
            commit('getStatsListFail');
        });
    }
};

var mutations = {
    getTableStatsList: function getTableStatsList(state, params) {
        state.loadingShow = false;
        state.currentListData = [];
        if (params.content && params.content.rounds && params.content.rounds.length) {
            state.noDataMode = false;
            putLocalTimeToData(params.content.rounds);
            state.currentListData = params.content.rounds;
            return;
        }
        state.noDataMode = true;
    },
    getGoalsStatsList: function getGoalsStatsList(state, params) {
        state.loadingShow = false;
        state.currentListData = {};
        if (params.content && params.content.data && params.content.data.length) {
            state.noDataMode = false;
            state.currentListData = params.content;
            return;
        }
        state.noDataMode = true;
    },
    getFixturesStatsList: function getFixturesStatsList(state, params) {
        state.loadingShow = false;
        state.currentListData = {};
        if (params.content && params.content.matches && params.content.matches.length) {
            state.noDataMode = false;
            state.currentListData = params.content;
            return;
        }
        state.noDataMode = true;
    },
    getStatsListFail: function getStatsListFail(state) {
        state.loadingShow = false;
        state.noDataMode = true;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_index__ = __webpack_require__(36);



var state = {
    noDataMode: false,
    loadingShow: false,
    toggleLoadingShow: false,
    currentListData: [],
    loadPrev: '',
    loadNext: ''
};

var getters = {
    getVideoNoDataMode: function getVideoNoDataMode(state) {
        return state.noDataMode;
    },
    getVideoLoadingShow: function getVideoLoadingShow(state) {
        return state.loadingShow;
    },
    getCurrentVideoListData: function getCurrentVideoListData(state) {
        return state.currentListData;
    },
    getVideoLoadPrev: function getVideoLoadPrev(state) {
        return state.loadPrev;
    },
    getVideoLoadNext: function getVideoLoadNext(state) {
        return state.loadNext;
    },
    getToggleLoadingShow: function getToggleLoadingShow(state) {
        return state.toggleLoadingShow;
    }
};

var actions = {
    videoListApi: function videoListApi(_ref, _ref2) {
        var commit = _ref.commit,
            state = _ref.state;
        var urlApi = _ref2.urlApi,
            type = _ref2.type;

        if (type === 2) {
            state.loadingShow = true;
        } else {
            state.toggleLoadingShow = true;
            state.currentListData = [];
        }
        return __WEBPACK_IMPORTED_MODULE_1__api_index__["i" /* videoApi */].getVideoList(urlApi).then(function (response) {
            commit('getVideoList', response);
        }, function (error) {
            commit('getVideoListFail');
            console.log('error', error);
        });
    }
};

var mutations = {
    showLoading: function showLoading(state, params) {
        state.loadingShow = params.isShow;
    },
    getVideoList: function getVideoList(state, params) {
        state.loadingShow = false;
        state.toggleLoadingShow = false;
        if (params.articles.length) {
            state.noDataMode = false;
            state.currentListData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.currentListData), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(params.articles));
            if (!!params.next) {
                state.loadNext = params.next.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '');
            } else {
                state.loadNext = false;
            }
            state.loadPrev = params.prev.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '');
        } else {
            state.noDataMode = true;
            state.loadNext = false;
        }
    },
    getVideoListFail: function getVideoListFail(state) {
        state.loadingShow = false;
        state.toggleLoadingShow = false;
        state.noDataMode = true;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(36);


var requestConfig = __webpack_require__(82);
var apiDomain =  false ? requestConfig.apiDomain3 : '';

var state = {
    loading: true,
    articleInfo: {}
};

var getters = {
    getArticleInfo: function getArticleInfo(state) {
        return state.articleInfo;
    }
};

var actions = {
    getArticleInfo: function getArticleInfo(_ref, _ref2) {
        var commit = _ref.commit,
            state = _ref.state;
        var article_id = _ref2.article_id;

        state.loading = true;
        var url = apiDomain + '/app/tweet/info?type=tweet&id=' + article_id;
        __WEBPACK_IMPORTED_MODULE_1__api__["h" /* tweetApi */].fetchTweetArticleInfo(url).then(function (data) {
            return commit('setTweetArticleInfo', { data: data });
        });
    }
};

var mutations = {
    setTweetArticleInfo: function setTweetArticleInfo(state, params) {
        state.loading = false;

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.articleInfo, params.data.data.id, params.data.data || false);
        console.log(state.articleInfo, 'articleInfo');
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(475),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(473);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("5abbff80", content, true);

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"App.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process, global) {

var requestConfig = __webpack_require__(82);
process.appDomain = requestConfig.appDomain;
process.staticDomain = requestConfig.staticDomain;

global.apiDomain = '';


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'App',
    metaInfo: {
        title: 'All Football'
    },
    created: function created() {},
    mounted: function mounted() {},
    methods: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(87), __webpack_require__(55)))

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

var perf = function perf() {
    if (!window.performance || !window.performance.getEntries) {
        return;
    }

    var getAverageValue = function getAverageValue(arr) {
        var sum = 0;
        for (var i = 0; i < arr.length; i++) {
            sum += Number(arr[i]);
        }
        return Math.floor(sum / arr.length);
    };

    var getHost = function getHost(url) {
        if (url.indexOf('//') < 0) {
            return url;
        }
        var host_path = url.split('//')[1];

        return host_path.split('/')[0];
    };

    var getMax = function getMax(arr) {
        var max = arr[0];
        for (var i = 1; i < arr.length; i++) {
            var element = arr[i];
            if (element > max) {
                max = element;
            }
        }
        return parseInt(max, 10);
    };

    var getMin = function getMin(arr) {
        var min = arr[0];
        for (var i = 1; i < arr.length; i++) {
            var element = arr[i];
            if (element < min) {
                min = element;
            }
        }
        return parseInt(min, 10);
    };

    var handleNavigation = function handleNavigation(element) {
        var paint = performance.getEntriesByType('paint');
        var paintStartTime = 0;
        if (paint && paint.length) {
            paintStartTime = paint[0].startTime || 0;
        }

        var times = {
            DNS: element.domainLookupEnd - element.domainLookupStart,
            CONNECT: element.connectEnd - element.connectStart,
            REQUEST: element.responseEnd - element.requestStart,
            PAINT: paintStartTime - element.responseEnd
        };

        for (var i in times) {
            if (parseInt(times[i], 10) > 0) {
                ga('send', 'timing', 'NAVIGATION', i, parseInt(times[i], 10), location.hostname);
            }
        }
    };
    var getEntries = window.performance.getEntries();

    var imgObj = {};

    var ajaxObj = {};

    var jsRequeststartArr = [];
    var jsResponseEndArr = [];
    var jsHostname = void 0;
    var cssRequeststartArr = [];
    var cssResponseEndArr = [];
    var cssHostname = void 0;

    for (var i = 0; i < getEntries.length; i++) {
        var element = getEntries[i];
        var hostname = getHost(element.name);

        if (hostname.indexOf('allfootballapp') < 0 && hostname.indexOf('dongqiudi') < 0) {
            continue;
        }

        if (element.initiatorType === 'script') {
            jsRequeststartArr.push(element.requestStart || element.startTime);
            jsResponseEndArr.push(element.responseEnd);
            jsHostname = element.name;
        } else if (element.initiatorType === 'link') {
            cssRequeststartArr.push(element.requestStart || element.startTime);
            cssResponseEndArr.push(element.responseEnd);
            cssHostname = element.name;
        } else if (element.initiatorType === 'xmlhttprequest') {
            if (!ajaxObj[getHost(element.name)]) {
                ajaxObj[getHost(element.name)] = element.duration.toString();
            } else {
                ajaxObj[getHost(element.name)] = ajaxObj[getHost(element.name)] + ',' + element.duration;
            }
        } else if (element.initiatorType === 'img') {
            if (!imgObj[getHost(element.name)]) {
                imgObj[getHost(element.name)] = element.duration.toString();
            } else {
                imgObj[getHost(element.name)] = imgObj[getHost(element.name)] + ',' + element.duration;
            }
        }
        if (element.entryType === 'navigation') {
            handleNavigation(element);
        }
    }

    for (var key in imgObj) {
        var imgArr = imgObj[key].split(',');
        imgObj[key] = imgArr;
        ga('send', 'timing', 'IMG', 'duration', getAverageValue(imgArr), key);
    }

    for (var _key in ajaxObj) {
        var ajaxArr = ajaxObj[_key].split(',');
        ajaxObj[_key] = ajaxArr;
        console.log(ajaxArr);
        ga('send', 'timing', 'AJAX', 'duration', getAverageValue(ajaxArr), _key);
        console.log('平均值', getAverageValue(ajaxArr));
    }

    ga('send', 'timing', 'JS', 'duration', getMax(jsResponseEndArr) - getMin(jsRequeststartArr), jsHostname);

    ga('send', 'timing', 'CSS', 'duration', getMax(cssResponseEndArr) - getMin(cssRequeststartArr), cssHostname);
};

if (typeof window !== 'undefined' && window.addEventListener && Math.random() < 0.01) {
    window.addEventListener('load', function () {
        setTimeout(perf, 2000);
    });
}

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

/* eslint no-extend-native:0 */
Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
};


/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(480);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("39f11079", content, true);

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(undefined);
// imports


// module
exports.push([module.i, "* {\n    margin: 0;\n    padding: 0;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    -webkit-touch-callout: none;\n    /*font-family: SF UI Display Mediu,Source Han Sans,Arial,Helvetica Neue,Helvetica,sans-serif;*/\n    font-family: sans-serif;\n    -webkit-font-smoothing: antialiased;\n}\n\nhtml::-webkit-scrollbar {\n    display: none;\n}\n\nbody::-webkit-scrollbar {\n    display: none;\n}\n\nbody, img {\n    width: 100%;\n}\n\na {\n    text-decoration: none;\n}\n\n.fl {\n    float: left;\n}\n\n.fr {\n    float: right;\n}\n\n.clearfix:after {\n    visibility: hidden;\n    display: block;\n    font-size: 0;\n    content: \" \";\n    clear: both;\n    height: 0;\n}\n\n.clear {\n    clear: both;\n}\n\n@media screen and (min-width: 320px) {\n    html {\n        font-size: 14px;\n    }\n}\n\n@media screen and (min-width: 360px) {\n    html {\n        font-size: 16px;\n    }\n}\n\n/*@media screen and (min-width: 375px) {\n    html {font-size: 17px;}\n}*/\n\n@media screen and (min-width: 400px) {\n    html {\n        font-size: 18px;\n    }\n}\n\n@media screen and (min-width: 440px) {\n    html {\n        font-size: 20px;\n    }\n}\n\n@media screen and (min-width: 480px) {\n    html {\n        font-size: 22px;\n    }\n}\n\n@media screen and (min-width: 640px) {\n    html {\n        font-size: 28px;\n    }\n}", ""]);

// exports


/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(482);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("6ad32c7d", content, true);

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(undefined);
// imports


// module
exports.push([module.i, ".lx-toast {\r\n    position: fixed;\r\n    bottom: 100px;\r\n    left: 50%;\r\n    box-sizing: border-box;\r\n    max-width: 80%;\r\n    height: 40px;\r\n    line-height: 20px;\r\n    padding: 10px 20px;\r\n    transform: translateX(-50%);\r\n    -webkit-transform: translateX(-50%);\r\n    text-align: center;\r\n    z-index: 9999;\r\n    font-size: 14px;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n    background: rgba(0, 0, 0, 0.7);\r\n    animation: show-toast .5s;\r\n    -webkit-animation: show-toast .5s;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.lx-toast.lx-word-wrap {\r\n    width: 80%;\r\n    white-space: inherit;\r\n    height: auto;\r\n}\r\n\r\n.lx-toast.lx-toast-top {\r\n    top: 50px;\r\n    bottom: inherit;\r\n}\r\n\r\n.lx-toast.lx-toast-center {\r\n    top: 50%;\r\n    margin-top: -20px;\r\n    bottom: inherit;\r\n}\r\n\r\n@keyframes show-toast {\r\n    from {\r\n        opacity: 0;\r\n        transform: translate(-50%, -10px);\r\n        -webkit-transform: translate(-50%, -10px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translate(-50%, 0);\r\n        -webkit-transform: translate(-50%, 0);\r\n    }\r\n}\r\n\r\n.lx-load-mark {\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 9999;\r\n}\r\n\r\n.lx-load-box {\r\n    position: fixed;\r\n    z-index: 3;\r\n    width: 7.6em;\r\n    min-height: 7.6em;\r\n    top: 180px;\r\n    left: 50%;\r\n    margin-left: -3.8em;\r\n    background: rgba(0, 0, 0, 0.7);\r\n    text-align: center;\r\n    border-radius: 5px;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.lx-load-content {\r\n    margin-top: 64%;\r\n    font-size: 14px;\r\n}\r\n\r\n.lx-loading {\r\n    position: absolute;\r\n    width: 0px;\r\n    left: 50%;\r\n    top: 38%;\r\n}\r\n\r\n.loading_leaf {\r\n    position: absolute;\r\n    top: -1px;\r\n    opacity: 0.25;\r\n}\r\n\r\n.loading_leaf:before {\r\n    content: \" \";\r\n    position: absolute;\r\n    width: 9.14px;\r\n    height: 3.08px;\r\n    background: #d1d1d5;\r\n    box-shadow: rgba(0, 0, 0, 0.0980392) 0px 0px 1px;\r\n    border-radius: 1px;\r\n    -webkit-transform-origin: left 50% 0px;\r\n    transform-origin: left 50% 0px;\r\n}\r\n\r\n.loading_leaf_0 {\r\n    -webkit-animation: opacity-0 1.25s linear infinite;\r\n    animation: opacity-0 1.25s linear infinite;\r\n}\r\n\r\n.loading_leaf_0:before {\r\n    -webkit-transform: rotate(0deg) translate(7.92px, 0px);\r\n    transform: rotate(0deg) translate(7.92px, 0px);\r\n}\r\n\r\n.loading_leaf_1 {\r\n    -webkit-animation: opacity-1 1.25s linear infinite;\r\n    animation: opacity-1 1.25s linear infinite;\r\n}\r\n\r\n.loading_leaf_1:before {\r\n    -webkit-transform: rotate(30deg) translate(7.92px, 0px);\r\n    transform: rotate(30deg) translate(7.92px, 0px);\r\n}\r\n\r\n.loading_leaf_2 {\r\n    -webkit-animation: opacity-2 1.25s linear infinite;\r\n    animation: opacity-2 1.25s linear infinite;\r\n}\r\n\r\n.loading_leaf_2:before {\r\n    -webkit-transform: rotate(60deg) translate(7.92px, 0px);\r\n    transform: rotate(60deg) translate(7.92px, 0px);\r\n}\r\n\r\n.loading_leaf_3 {\r\n    -webkit-animation: opacity-3 1.25s linear infinite;\r\n    animation: opacity-3 1.25s linear infinite;\r\n}\r\n\r\n.loading_leaf_3:before {\r\n    -webkit-transform: rotate(90deg) translate(7.92px, 0px);\r\n    transform: rotate(90deg) translate(7.92px, 0px);\r\n}\r\n\r\n.loading_leaf_4 {\r\n    -webkit-animation: opacity-4 1.25s linear infinite;\r\n    animation: opacity-4 1.25s linear infinite;\r\n}\r\n\r\n.loading_leaf_4:before {\r\n    -webkit-transform: rotate(120deg) translate(7.92px, 0px);\r\n    transform: rotate(120deg) translate(7.92px, 0px);\r\n}\r\n\r\n.loading_leaf_5 {\r\n    -webkit-animation: opacity-5 1.25s linear infinite;\r\n    animation: opacity-5 1.25s linear infinite;\r\n}\r\n\r\n.loading_leaf_5:before {\r\n    -webkit-transform: rotate(150deg) translate(7.92px, 0px);\r\n    transform: rotate(150deg) translate(7.92px, 0px);\r\n}\r\n\r\n.loading_leaf_6 {\r\n    -webkit-animation: opacity-6 1.25s linear infinite;\r\n    animation: opacity-6 1.25s linear infinite;\r\n}\r\n\r\n.loading_leaf_6:before {\r\n    -webkit-transform: rotate(180deg) translate(7.92px, 0px);\r\n    transform: rotate(180deg) translate(7.92px, 0px);\r\n}\r\n\r\n.loading_leaf_7 {\r\n    -webkit-animation: opacity-7 1.25s linear infinite;\r\n    animation: opacity-7 1.25s linear infinite;\r\n}\r\n\r\n.loading_leaf_7:before {\r\n    -webkit-transform: rotate(210deg) translate(7.92px, 0px);\r\n    transform: rotate(210deg) translate(7.92px, 0px);\r\n}\r\n\r\n.loading_leaf_8 {\r\n    -webkit-animation: opacity-8 1.25s linear infinite;\r\n    animation: opacity-8 1.25s linear infinite;\r\n}\r\n\r\n.loading_leaf_8:before {\r\n    -webkit-transform: rotate(240deg) translate(7.92px, 0px);\r\n    transform: rotate(240deg) translate(7.92px, 0px);\r\n}\r\n\r\n.loading_leaf_9 {\r\n    -webkit-animation: opacity-9 1.25s linear infinite;\r\n    animation: opacity-9 1.25s linear infinite;\r\n}\r\n\r\n.loading_leaf_9:before {\r\n    -webkit-transform: rotate(270deg) translate(7.92px, 0px);\r\n    transform: rotate(270deg) translate(7.92px, 0px);\r\n}\r\n\r\n.loading_leaf_10 {\r\n    -webkit-animation: opacity-10 1.25s linear infinite;\r\n    animation: opacity-10 1.25s linear infinite;\r\n}\r\n\r\n.loading_leaf_10:before {\r\n    -webkit-transform: rotate(300deg) translate(7.92px, 0px);\r\n    transform: rotate(300deg) translate(7.92px, 0px);\r\n}\r\n\r\n.loading_leaf_11 {\r\n    -webkit-animation: opacity-11 1.25s linear infinite;\r\n    animation: opacity-11 1.25s linear infinite;\r\n}\r\n\r\n.loading_leaf_11:before {\r\n    -webkit-transform: rotate(330deg) translate(7.92px, 0px);\r\n    transform: rotate(330deg) translate(7.92px, 0px);\r\n}\r\n\r\n@-webkit-keyframes opacity-0 {\r\n    0% {\r\n        opacity: 0.25;\r\n    }\r\n    0.01% {\r\n        opacity: 0.25;\r\n    }\r\n    0.02% {\r\n        opacity: 1;\r\n    }\r\n    60.01% {\r\n        opacity: 0.25;\r\n    }\r\n    100% {\r\n        opacity: 0.25;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes opacity-1 {\r\n    0% {\r\n        opacity: 0.25;\r\n    }\r\n    8.34333% {\r\n        opacity: 0.25;\r\n    }\r\n    8.35333% {\r\n        opacity: 1;\r\n    }\r\n    68.3433% {\r\n        opacity: 0.25;\r\n    }\r\n    100% {\r\n        opacity: 0.25;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes opacity-2 {\r\n    0% {\r\n        opacity: 0.25;\r\n    }\r\n    16.6767% {\r\n        opacity: 0.25;\r\n    }\r\n    16.6867% {\r\n        opacity: 1;\r\n    }\r\n    76.6767% {\r\n        opacity: 0.25;\r\n    }\r\n    100% {\r\n        opacity: 0.25;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes opacity-3 {\r\n    0% {\r\n        opacity: 0.25;\r\n    }\r\n    25.01% {\r\n        opacity: 0.25;\r\n    }\r\n    25.02% {\r\n        opacity: 1;\r\n    }\r\n    85.01% {\r\n        opacity: 0.25;\r\n    }\r\n    100% {\r\n        opacity: 0.25;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes opacity-4 {\r\n    0% {\r\n        opacity: 0.25;\r\n    }\r\n    33.3433% {\r\n        opacity: 0.25;\r\n    }\r\n    33.3533% {\r\n        opacity: 1;\r\n    }\r\n    93.3433% {\r\n        opacity: 0.25;\r\n    }\r\n    100% {\r\n        opacity: 0.25;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes opacity-5 {\r\n    0% {\r\n        opacity: 0.270958333333333;\r\n    }\r\n    41.6767% {\r\n        opacity: 0.25;\r\n    }\r\n    41.6867% {\r\n        opacity: 1;\r\n    }\r\n    1.67667% {\r\n        opacity: 0.25;\r\n    }\r\n    100% {\r\n        opacity: 0.270958333333333;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes opacity-6 {\r\n    0% {\r\n        opacity: 0.375125;\r\n    }\r\n    50.01% {\r\n        opacity: 0.25;\r\n    }\r\n    50.02% {\r\n        opacity: 1;\r\n    }\r\n    10.01% {\r\n        opacity: 0.25;\r\n    }\r\n    100% {\r\n        opacity: 0.375125;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes opacity-7 {\r\n    0% {\r\n        opacity: 0.479291666666667;\r\n    }\r\n    58.3433% {\r\n        opacity: 0.25;\r\n    }\r\n    58.3533% {\r\n        opacity: 1;\r\n    }\r\n    18.3433% {\r\n        opacity: 0.25;\r\n    }\r\n    100% {\r\n        opacity: 0.479291666666667;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes opacity-8 {\r\n    0% {\r\n        opacity: 0.583458333333333;\r\n    }\r\n    66.6767% {\r\n        opacity: 0.25;\r\n    }\r\n    66.6867% {\r\n        opacity: 1;\r\n    }\r\n    26.6767% {\r\n        opacity: 0.25;\r\n    }\r\n    100% {\r\n        opacity: 0.583458333333333;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes opacity-9 {\r\n    0% {\r\n        opacity: 0.687625;\r\n    }\r\n    75.01% {\r\n        opacity: 0.25;\r\n    }\r\n    75.02% {\r\n        opacity: 1;\r\n    }\r\n    35.01% {\r\n        opacity: 0.25;\r\n    }\r\n    100% {\r\n        opacity: 0.687625;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes opacity-10 {\r\n    0% {\r\n        opacity: 0.791791666666667;\r\n    }\r\n    83.3433% {\r\n        opacity: 0.25;\r\n    }\r\n    83.3533% {\r\n        opacity: 1;\r\n    }\r\n    43.3433% {\r\n        opacity: 0.25;\r\n    }\r\n    100% {\r\n        opacity: 0.791791666666667;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes opacity-11 {\r\n    0% {\r\n        opacity: 0.895958333333333;\r\n    }\r\n    91.6767% {\r\n        opacity: 0.25;\r\n    }\r\n    91.6867% {\r\n        opacity: 1;\r\n    }\r\n    51.6767% {\r\n        opacity: 0.25;\r\n    }\r\n    100% {\r\n        opacity: 0.895958333333333;\r\n    }\r\n}", ""]);

// exports


/***/ }),

/***/ 483:
/***/ (function(module, exports) {

module.exports = {
    en: {
        open: 'open',
        hide: 'hide',
        ago: 'ago',
        aYear: 'a year ago',
        aMonth: 'a month ago',
        months: 'months',
        aWeek: 'a week ago',
        week: 'weeks',
        hour: 'an hour ago',
        hours: 'hours',
        minute: '1 minute ago',
        minutes: 'minutes',
        day: 'a day ago',
        days: 'days',
        yesterday: 'Yesterday',
        today: 'Today',
        justNow: 'just now',
        vote: 'Vote',
        voted: 'voted',
        voteSub: 'Vote Submitted',
        voteFail: 'Vote failed, please retry~',
        submit: 'Submit',
        matchVoted: 'You have already voted~',
        thanksVote: 'Thanks for voting',
        voteOver: 'Voting is over',
        comments: 'Comments',
        addComment: 'Add a comment',
        readMore: 'Read more comments',
        noCommented: 'No one has commented yet',
        likedAlready: "You've liked it already",
        reply: 'Reply',
        related: 'Related',
        Copyright: 'Copyright Declaration',
        mayLike: 'You may like',
        aOption: 'option most',
        options: 'options most',
        downloadForComments: 'Download All Football for more comments',

        bestApp: 'The Best App for Football Fans',
        downloadForCoin: 'Top-notch tips & predictions from the most experienced experts, fastest & most accurate data on the hottest matches -- Download now!',
        download: 'Download',
        shareForCoin: 'STRONGLY recommend this amazing football app to you!',
        copy: 'Copy',
        copySuccess: 'Copy successfully',
        AboutUserPosts: 'About User Posts',
        Report: 'Report',
        Follow: 'Follow',
        Following: 'Following',
        bonus: 'Bonus',
        startTime: 'Start time',
        inviteOther: 'Invite others to participate in the game, you will get resurrection cards',
        invite: 'Invite',
        rules: 'Game Rules',
        goAnswer: 'Go answering',
        leasePogin: 'Please login to participate in the answer',
        share: 'Enter the invitation code, your friend and you will both get a resurrection card.',
        shareBouns: 'I got bonus in All Football',
        shareComm: 'Answer all 12 questions to share the big prize',
        login: 'Login',
        enterInv: 'Enter invitation code',
        inviteFriend: 'Invite others to get extra lives',
        receiveDuration1: 'Please enter your Paypal account.',
        receiveDuration2: 'We will give you a bonus within 1week.',
        receiveConfirm: 'Confirm',
        receiveSubmited: 'Your information has been submited',
        receiveExpired: 'The page has expired',
        gotCard: 'You got a resurrection card',
        title: 'Super Football Hero',
        timeLeft: 'Time left',
        copied: 'Copied',
        copyFailed: 'Copy failed, please retry'
    },
    zh_cn: {
        open: '打开',
        hide: '隐藏',
        aYear: '一年前',
        aMonth: '一个月前',
        months: '月前',
        aWeek: '一周前',
        week: '周',
        hour: '时前',
        hours: '时前',
        minute: '分前',
        minutes: '分前',
        day: '天前',
        days: '天前',
        yesterday: '昨天',
        today: '今天',
        justNow: '现在',
        vote: '投票',
        voted: '已投',
        voteFail: '投票失败，请重试~',
        submit: '提交',
        matchVoted: '你已经投过票了~',
        thanksVote: '感谢投票~',
        voteOver: '投票已结束~',
        comments: '评论',
        addComment: '写个评论',
        readMore: '看更多评论',
        noCommented: '没有人评论过',
        likedAlready: '你已经点赞过了',
        reply: '回复',
        related: '相关',
        Copyright: '版权声明',
        mayLike: '猜你喜欢',
        aOption: 'option most',
        options: 'options most',
        AboutUserPosts: 'About User Posts',
        Report: 'Report',
        Follow: 'Follow',
        Following: 'Following'

    },
    es: {
        open: 'abrir',
        hide: 'esconder',
        ago: 'hace',
        aYear: 'hace un año',
        aMonth: 'hace un mes',
        months: 'meses',
        aWeek: 'hace una semana',
        week: 'semanas',
        hour: 'hace una hora',
        hours: 'horas',
        minute: 'hace un minuto',
        minutes: 'minutos',
        day: 'hace un día',
        days: 'días',
        yesterday: 'ayer',
        today: 'hoy',
        justNow: 'Ahora mismo',
        vote: 'votar',
        voted: 'votado',
        voteSub: 'Voto Emitido',
        voteFail: 'La votación no funcionó, vuelve a intentarlo~',
        submit: 'someter',
        matchVoted: 'Ya has votado~',
        thanksVote: 'Gracias por votar',
        voteOver: 'La votación termina',
        comments: 'Comentarios',
        addComment: 'Comenta',
        readMore: 'Mas comentarios',
        noCommented: 'Nadie ha comentado todavía',
        likedAlready: 'Ya lo has gustado',
        reply: 'Responder',
        related: 'Relacionado',
        Copyright: 'Declaración de Copyright',
        mayLike: 'Te podría interesar',
        aOption: 'opción al máximo',
        options: 'opciones al máximo',
        downloadForComments: 'Descargue All Football para más comentarios',

        bestApp: 'La mejor app para los fanáticos del fútbol',
        downloadForCoin: 'Después de instalar la app, indique el código de invitación. El invitador se ganará 30 puntos de AF',
        download: 'Descargar',
        shareForCoin: 'Recomiendo fuertemente esta fantástica aplicación de fútbol!',
        copy: 'Copiar',
        copySuccess: 'Copiar con éxito',
        AboutUserPosts: 'Denunciar Posts de usuarios',
        Report: 'Sobre',
        Follow: 'Seguir',
        Following: 'Siguiendo',
        title: '¡Trae dinero a casa! Ven a responder a las preguntas y ganar dinero',
        timeLeft: 'Tiempo restante'
    },
    vi: {
        downloadForCoin: 'Cập nhật thông tin tức thời , Dự đoán tỷ số và phân tích trận đấu chuyên nghiệp',
        bestApp: 'Ứng dụng tuyệt vời nhất dành cho fans bóng đá',
        copy: 'Sao chép',
        download: 'Tải về ngay thôi!!'
    }
};

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

var request_config = {
    appDomain: 'api.beta.allfootballapp.com',
    apiDomain: 'beta-m-api.allfootballapp.com',
    staticDomain: 'allfootball-static.dongqiudi.com/node',
    apiDomain2: 'beta-api.allfootballapp.com',
    apiDomain3: 'beta-article.allfootballapp.com'
};

module.exports = {
    appDomain: 'https://'+request_config.appDomain,
    apiDomain: 'https://'+request_config.apiDomain,
    staticDomain: 'https://'+request_config.staticDomain,
    apiDomain2: 'https://'+request_config.apiDomain2,
    apiDomain3: 'https://'+request_config.apiDomain3
};



/***/ })

},[331]);


// WEBPACK FOOTER //
// static/js/app.2c1ec1fa6b424ef1693e.js